import { ref, onBeforeUnmount } from 'vue';

// Refaz o pedido a cada `interval`, um de cada vez: o próximo só é agendado
// depois que o anterior volta. `ativo` e a cadeia vigente fecham os dois furos
// de antes: `stop` com um pedido em voo deixava a cadeia viva quando a resposta
// chegava, e `start` duas vezes abria duas cadeias, e o `stop` só parava uma.
export const useLiveRefresh = (callback, interval = 60000) => {
  const timeoutId = ref(null);
  let ativo = false;
  let cadeia = 0;

  const stopRefetching = () => {
    ativo = false;
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
      timeoutId.value = null;
    }
  };

  const startRefetching = () => {
    stopRefetching();
    ativo = true;
    cadeia += 1;
    const desta = cadeia;
    const agendar = () => {
      timeoutId.value = setTimeout(async () => {
        timeoutId.value = null;
        await callback();
        if (ativo && desta === cadeia) agendar();
      }, interval);
    };
    agendar();
  };

  onBeforeUnmount(() => {
    stopRefetching();
  });

  return {
    startRefetching,
    stopRefetching,
  };
};
